/*
  Shareable renderer for displaying the name of a library model (dashboard, observation deck, saved view).
  Largely a copy/paste from the original table column.
*/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { observer } from 'mobx-react';
import BoardModel from 'app/stores/boards/BoardModel';
import DashboardModel from 'app/stores/dashboard/DashboardModel';
import SavedView from 'app/stores/savedView/SavedView';
import { Box, Flex, Icon, Link, Tag, Text } from 'core/components';
import LabelList from 'app/components/labels/LabelList';
import GuidedViewForm from 'app/views/core/GuidedViewForm';

interface Props {
  model: BoardModel | DashboardModel | SavedView;
  showParametric?: boolean;
}

function LibraryNameRenderer({ model, showParametric = true }: Props) {
  const { description, view_description } = model.get();

  return (
    <>
      <Flex alignItems="center" width="100%" gap={2}>
        <Link
          fontWeight="bold"
          fontSize={16}
          ellipsis
          maxWidth="100%"
          to={model.navigatePath}
          style={{ minWidth: 'min-content' }}
        >
          {model.name}
        </Link>

        {model.isTrending && (
          <Flex>
            <Tag icon={<Icon icon="flame" intent="warning" />} py={0} minHeight={18}>
              <Text>Trending</Text>
            </Tag>
          </Flex>
        )}

        {model.get('draft') && (
          <Tag icon="dot" intent="warning" py={0} minHeight={18}>
            Draft
          </Tag>
        )}
      </Flex>
      {(description || view_description) && (
        <Text ellipsis small muted width="100%">
          {description || view_description}
        </Text>
      )}

      <LabelList
        labels={model.labels}
        shareLevel={model.shareLevel}
        priorityLabels={model.collection.discreteFilterValues.labelMultiSelect}
        labelMaxWidth={200}
      />

      {showParametric && model.isParametric && (
        <Box maxWidth={400} width="100%">
          <GuidedViewForm view={model} textStyle={{ marginBottom: 0 }} />
        </Box>
      )}
    </>
  );
}

export default observer(LibraryNameRenderer);
